import Nullstack from 'nullstack';
export default function IconBasketOff({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-basket-off",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M7 10l1.359 -1.63"
  }), "   ", Nullstack.element("path", {
    d: "M10.176 6.188l1.824 -2.188l5 6"
  }), "   ", Nullstack.element("path", {
    d: "M18.77 18.757c-.358 .768 -1.027 1.262 -1.77 1.243h-10c-.966 .024 -1.807 -.817 -2 -2l-2 -8h7"
  }), "   ", Nullstack.element("path", {
    d: "M14 10h7l-1.397 5.587"
  }), "   ", Nullstack.element("circle", {
    cx: "12",
    cy: "15",
    r: "2"
  }), "   ", Nullstack.element("path", {
    d: "M3 3l18 18"
  }), " ");
}